<!--
    Single Selected Facility Modal.
-->
<div class="modal fade" bsModal #singleFacilityModal="bs-modal"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">Single Facility Selection Required</h4>
            </div>
            <div class="modal-body">
                Please choose a single facility to view this section.
            </div>
            <div style="height: 50px; padding-left: 10px">
                <div dropdown class="dropdown" [autoClose]="true">
                    <button dropdownToggle class="btn btn-dropdown dropdown-link">
                        {{selectedFacility ? selectedFacility.name : ''}}
                        <span style="margin-left: 5px" class="caret"></span>
                    </button>
                    <ul *dropdownMenu class="select-dropdown dropdown-menu" role="menu">
                        <li role="menuitem" (click)="onClickFacility(facility)" *ngFor="let facility of facilities">
                            <div class="dropdown-item"
                                [tooltip]="getFacilityTooltipText(facility)">
                                {{facility.name}}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <div class="col-6 text-align-right">
                    <button class="btn btn-primary" (click)="closeModal(singleFacilityModal)">Continue with this facility</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <my-message-box-modal   buttonText = "OK"
                            [modalHeader] = "modalHeader"
                            [displayText]= "displayText"
                            [hideCancelButton]=true
                            (modalClosing)="onModalClose()">
    </my-message-box-modal>
</div>
